import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import {
  WORKSPACE_PRODUCTS,
  detectWorkspaceProduct,
} from '../config/productWorkspaceConfig';

const SupportWidgetContext = createContext(null);

export const useSupportWidget = () => {
  const ctx = useContext(SupportWidgetContext);
  if (!ctx) {
    return {
      isOpen: false,
      product: WORKSPACE_PRODUCTS.SELF_REPAIR,
      openSupportWidget: () => {},
      closeSupportWidget: () => {},
      composerRef: { current: null },
    };
  }
  return ctx;
};

export const SupportWidgetProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState(() => detectWorkspaceProduct());
  const composerRef = useRef(null);

  const openSupportWidget = useCallback((options = {}) => {
    const nextProduct = options.product || detectWorkspaceProduct();
    setProduct(nextProduct);
    setIsOpen(true);
    window.setTimeout(() => {
      composerRef.current?.focus?.();
    }, 280);
  }, []);

  const closeSupportWidget = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SupportWidgetContext.Provider
      value={{ isOpen, product, openSupportWidget, closeSupportWidget, composerRef }}
    >
      {children}
    </SupportWidgetContext.Provider>
  );
};

export default SupportWidgetContext;
